<template>
	<div class="recovery_case">
		<h1 class="title">康复案例</h1>
		<h2 class="en_title">REHABILITATION CASES</h2>
		<div class="swiper_box">
			<div class="swiper-container" style="height: 100%;">
				<div class="swiper-wrapper">
					<div class="swiper-slide">
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_04.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_01.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_06.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_03.jpg" alt="">
						</a>
					</div>
					<div class="swiper-slide">
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_05.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_07.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_08.jpg" alt="">
						</a>
						<a class="img" @click="handleItemClick">
							<img src="../../../../assets/case_02.jpg" alt="">
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="swiper_control">
			<i class="prev" @click="handlePrevClick"></i>
			<i class="next" @click="handleNextClick"></i>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {
			this.initSwiper();
		},
		methods: {
			/***************** @Events **********************/
			// 点击上一页
			handlePrevClick() {
				this.swiper_instance.slidePrev(300);
			},
			// 点击下一页
			handleNextClick() {
				this.swiper_instance.slideNext(300);
			},
			// 点击每一个案例
			handleItemClick() {
				this.$router.push({path: '/index/recovery_case'});
			},
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				this.swiper_instance = new this.Swiper ('.recovery_case .swiper-container', {
					loop: false,
					allowTouchMove: false
				});
			},
		}
	}
</script>

<style scoped>
	.recovery_case{ width: 1200px;margin: 130px auto 0; }
	.recovery_case .title{ font-size: 30px;font-weight: bold;text-align: center;line-height: 42px; }
	.recovery_case .en_title{ font-size: 24px;color: #ccc;text-align: center;line-height: 34px; }
	.recovery_case .swiper_box{ height: 240px;margin-top: 54px; }
	.recovery_case .img{ display: block;position: relative;float: left;width: 280px;height: 240px;margin: 0 10px;border-radius: 10px;overflow: hidden; }
	.recovery_case .img img{ display: block;position: absolute;width: 100%;top: 50%;left: 0;transform: translate(0, -50%);transition: all .3s ease-out; }
	.recovery_case .img:hover img{ transform: translate(0, -50%) scale(1.2, 1.2); }
	.recovery_case .swiper_control{ margin-top: 50px;text-align: center; }
	.recovery_case .prev{ display: inline-block;width: 40px;height: 40px;margin-right: 26px;background-image: url(../../../../assets/prev_circle_icon.png);background-size: cover;vertical-align: top; }
	.recovery_case .next{ display: inline-block;width: 40px;height: 40px;background-image: url(../../../../assets/next_circle_icon.png);background-size: cover;vertical-align: top; }
	.recovery_case .prev:hover{ background-image: url(../../../../assets/prev_on_circle_icon.png);background-size: cover;cursor: pointer; }
	.recovery_case .next:hover{ background-image: url(../../../../assets/next_on_circle_icon.png);background-size: cover;cursor: pointer; }
</style>
